// extracted by mini-css-extract-plugin
export default {"offcanvasMobileSearchArea":"MobileSearch_offcanvasMobileSearchArea__Ffn7-"};